export default __webpack_public_path__ + "static/media/Paragon_Logo.817f437d.png";